import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import {cancel, fork, put, select, take} from 'redux-saga/effects';
import {rsf} from '../../../globals/firebase';
import * as dashboardRoutines from '../dashboardRoutines'

function* syncPeerToPeerStatus() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleConfig(activeEvent, 'inbox', 'peerToPeer'), {
        successActionCreator: dashboardRoutines.syncPeerToPeerStatus.success,
        failureActionCreator: dashboardRoutines.syncPeerToPeerStatus.failure,
    });
}
export function* resetPeerToPeerStatusSync() {
    yield put(dashboardRoutines.stopSyncingPeerToPeerStatus.trigger());
    yield put(dashboardRoutines.syncPeerToPeerStatus());
}

export function* rootDashboardWatcher() {
    while (yield take(dashboardRoutines.syncPeerToPeerStatus.TRIGGER)) {
        const bgPeerToPeerStatus = yield fork(syncPeerToPeerStatus);
        yield take(dashboardRoutines.stopSyncingPeerToPeerStatus.TRIGGER);
        yield cancel(bgPeerToPeerStatus);
    }
}
